import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sales-shell',
  templateUrl: './sales-shell.component.html',
  styleUrls: ['./sales-shell.component.less'],
  standalone: false,
})
export class SalesShellComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
